import React from 'react';
import * as yup from 'yup';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import * as taxbillApi from '../../lib/api/taxbill';
import TaxBillIssuedForm from '../../components/taxIssuedmng/TaxBillIssuedForm';
import { setTaxbill } from '../../modules/taxIssuedModule/taxbill';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useEffect } from 'react';

const TaxBillIssuedFormContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState(0);
  const { taxbill, user } = useSelector(
    ({ taxIssuedModule, auth }) => ({
      taxbill: taxIssuedModule.taxbill.taxbill,
      user: auth.user,
    }),
  );

  const initialValues = {
    reqPlanDt: taxbill && taxbill.reqPlanDt !== null ? taxbill.reqPlanDt : '',
    reqPlanYn:
      taxbill && taxbill.reqPlanYn !== null && taxbill.reqPlanYn === 'Y'
        ? true
        : false,
    reqCompDt: taxbill && taxbill.reqCompDt !== null ? taxbill.reqCompDt : '',
    reqCompYn:
      taxbill && taxbill.reqCompYn !== null && taxbill.reqCompYn === 'Y'
        ? true
        : false,
    reqPlanTxt:
      taxbill && taxbill.reqPlanTxt !== null ? taxbill.reqPlanTxt : '',
    reqCompTxt:
      taxbill && taxbill.reqCompTxt !== null ? taxbill.reqCompTxt : '',
  };

  const validationSchema = yup.object({
    reqPlanDt: yup.date().nullable(),
    reqCompDt: yup.date().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSave = async (values) => {
    //console.log(values);
    let dataToSubmit = {
      invUuid: taxbill.invUuid,
      reqPlanDt: values.reqPlanDt
        ? dayjs(values.reqPlanDt).format('YYYY-MM-DD')
        : '',
      reqPlanYn: values.reqPlanYn ? 'Y' : 'N',
      reqPlanTxt: values.reqPlanTxt,
      reqCompDt: values.reqCompDt
        ? dayjs(values.reqCompDt).format('YYYY-MM-DD')
        : '',
      reqCompYn: values.reqCompYn ? 'Y' : 'N',
      reqCompTxt: values.reqCompTxt,
    };

    if (activeStep === 0) {
      dataToSubmit.reqPlanUsr = user.usrUuid;
    } else if (activeStep === 1) {
      dataToSubmit.reqCompUsr = user.usrUuid;
    }

    try {
      const res = await taxbillApi.editTaxbill(dataToSubmit);
      //console.log(res.data.info);
      if (res.data) {
        dispatch(setTaxbill(res.data.info));
        enqueueSnackbar('계산서 발행 저장 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  useEffect(() => {
    if (taxbill) {
      let step = getActiveStep(taxbill);
      setActiveStep(step);
    }
  }, [taxbill, activeStep, dispatch]);

  const getActiveStep = (taxbill) => {
    let step = 0;
    if (taxbill.reqPlanYn === 'Y' && taxbill.reqCompYn === 'N') {//발행완료여부 체크
      step = 1;
    } else if (taxbill.reqCompYn === 'Y' && taxbill.procPlanYn === 'N') {//지급(수금) 요청 체크
      step = 2;
    } else if (taxbill.procPlanYn === 'Y' && taxbill.procCompYn === 'N') {//지급(수금) 요청 체크

      step = 3;
    } else if (taxbill.procCompYn === 'Y' && taxbill.rsltCompYn === 'N') {//지급(수금) 요청 체크

      step = 4;
    } else if (taxbill.rsltCompYn === 'Y') {
      step = 5;
    }
    return step;
  }






  return <TaxBillIssuedForm formik={formik} activeStep={activeStep} taxbill={taxbill} />;
};

export default TaxBillIssuedFormContainer;
